import React, { useState } from "react";
import "./EmojiConnect.css";

const emojis = ["🍎","🍌","🚀","⚽","🐱","🐶","🌟","🎮"];

function shuffle(array) {
  return array.sort(() => Math.random() - 0.5);
}

export default function EmojiConnect() {
  const [grid, setGrid] = useState(shuffle([...emojis, ...emojis]));
  const [selected, setSelected] = useState([]);
  const [matched, setMatched] = useState([]);
  const [score, setScore] = useState(0);
  const [message, setMessage] = useState("");
  const [celebrate, setCelebrate] = useState(false);

  // Load sounds
  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  const handleClick = (index) => {
    if (selected.length === 2 || matched.includes(index)) return;
    setSelected([...selected, index]);

    if (selected.length === 1) {
      const firstIndex = selected[0];
      const secondIndex = index;
      if (grid[firstIndex] === grid[secondIndex]) {
        setMatched([...matched, firstIndex, secondIndex]);
        setScore(score + 10);
        setMessage("🎉 Match found!");
        correctSound.play();
        if (matched.length + 2 === grid.length) {
          setMessage("🏆 All pairs matched! Final Score: " + (score + 10));
          winSound.play();
          setCelebrate(true);
        }
      } else {
        setScore(score - 2);
        setMessage("❌ Not a match!");
        wrongSound.play();
        setTimeout(() => setSelected([]), 800);
        return;
      }
      setSelected([]);
    }
  };

  const restartGame = () => {
    setGrid(shuffle([...emojis, ...emojis]));
    setSelected([]);
    setMatched([]);
    setScore(0);
    setMessage("");
    setCelebrate(false);
  };

  return (
    <div className="connect-container">
      <h1>🔗 Emoji Connect</h1>
      <div className="stats">
        <p>⭐ Score: {score}</p>
      </div>
      <div className="grid">
        {grid.map((emoji, index) => (
          <div
            key={index}
            className={`cell
              ${selected.includes(index) ? "selected" : ""}
              ${matched.includes(index) ? "matched" : ""}`}
            onClick={() => handleClick(index)}
          >
            {selected.includes(index) || matched.includes(index) ? emoji : "❓"}
          </div>
        ))}
      </div>
      <p className="status">{message}</p>
      <button onClick={restartGame} className="restart-btn">🔄 Restart</button>

      {/* Confetti overlay */}
      {celebrate && (
        <div className="confetti">
          {Array(50).fill(null).map((_, i) => (
            <div key={i} className="confetti-piece" style={{"--i": i}}></div>
          ))}
        </div>
      )}
    </div>
  );
}
